import { Metadata } from "next";
import CalculatorConfig from "@/components/calculator-configuration/CalculatorConfig";

export const metadata: Metadata = {
  title: "Policy Configuration | Property Listing Admin",
  description:
    "Configure Singapore property tax policies including BSD, ABSD, SSD, LTV rates, and form validation limits",
};

const CalculatorFormulaPage = () => {
  return (
    <div className="container">
      <CalculatorConfig />
    </div>
  );
};

export default CalculatorFormulaPage;
